import { SearchInput as CompassSearchInput } from "@circleco/compass/components/SearchInput";
import { useEffect, useRef } from "react";

import { t } from "@/i18n-js/instance";

const SEARCH_DEBOUNCE_MS = 300;

interface SearchFieldProps {
  onChange: (value: string) => void;
}

export const SearchField = ({ onChange }: SearchFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className="mb-4">
      <CompassSearchInput
        ref={inputRef}
        placeholder={t("tiptap.search_giphy")}
        onSearch={onChange}
        debounceMs={SEARCH_DEBOUNCE_MS}
        onClear={() => onChange("")}
      />
    </div>
  );
};
